import { usePriceTagText } from './usePriceTagText';

export const priceTagLayoutProps = {
    values: {
        type: Object,
        required: true,
    },
    fieldsByKey: {
        type: Object,
        default: () => ({}),
    },
    errors: {
        type: Object,
        default: () => ({}),
    },
    editable: {
        type: Boolean,
        default: false,
    },
    context: {
        type: Object,
        required: true,
    },
};

export const priceTagLayoutEmits = ['update-value'];

export function usePriceTagLayout(props, emit) {
    const bindField = key => ({
        field: props.fieldsByKey[key],
        value: props.values[key],
        editable: props.editable && !!props.fieldsByKey[key],
        invalid: !!props.errors[key],
        onUpdate: value => emit('update-value', { key, value }),
    });

    return { bindField, ...usePriceTagText() };
}

export default usePriceTagLayout;
